// [Codex 2026-07-16] S139 persists chat sessions with a provider-neutral key.
import { useCallback, useEffect, useState } from "react";
import { fintheonConversationStorageKey } from "../lib/fintheonAgentRouting";

// [claude-code 2026-03-09] Added surfaceId for per-surface session isolation
export function usePersistentFintheonConversation(
  fintheonAgentId: string | undefined | null,
  surfaceId?: string,
) {
  const [conversationId, setConversationIdState] = useState<string | undefined>(
    undefined,
  );

  useEffect(() => {
    // Check if persistent thread is enabled in Gateway settings
    const persistentEnabled =
      localStorage.getItem("fintheon:gateway-persistent-thread-enabled") ===
      "true";
    const persistentId = localStorage.getItem(
      "fintheon:gateway-persistent-thread-id",
    );

    if (persistentEnabled && persistentId) {
      setConversationIdState(persistentId);
      return;
    }

    const key = fintheonConversationStorageKey(fintheonAgentId, surfaceId);
    const stored = localStorage.getItem(key) ?? undefined;
    setConversationIdState(stored);
  }, [fintheonAgentId, surfaceId]);

  const setConversationId = useCallback(
    (id: string) => {
      const key = fintheonConversationStorageKey(fintheonAgentId, surfaceId);
      localStorage.setItem(key, id);

      // Also update persistent thread ID if persistent mode is enabled
      const persistentEnabled =
        localStorage.getItem("fintheon:gateway-persistent-thread-enabled") ===
        "true";
      if (persistentEnabled) {
        localStorage.setItem("fintheon:gateway-persistent-thread-id", id);
      }

      setConversationIdState(id);
    },
    [fintheonAgentId, surfaceId],
  );

  const clearConversationId = useCallback(() => {
    // Only clear the per-agent key, not the persistent thread
    const key = fintheonConversationStorageKey(fintheonAgentId, surfaceId);
    localStorage.removeItem(key);
    setConversationIdState(undefined);
  }, [fintheonAgentId, surfaceId]);

  return { conversationId, setConversationId, clearConversationId };
}
